export const FLOOR_OPTIONS = [
  "-1",
  "0",
  "0.5",
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
];

export const CATEGORY_LABELS = {
  lux: "Lux",
  exclusive: "Ekskluzivna",
  new: "Nova",
  top: "Top",
  urgent: "Hitno",
  cheap: "Jeftina",
  top_studio: "Top Garsonjera",
};

export const RECOMMENDATION_LABELS = {
  lux: "Lux",
  exclusive: "Ekskluzivna",
  new: "Novogradnja",
  top: "Top pozicija u pretrazi",
  urgent: "Hitno",
  cheap: "Jeftina",
  top_studio: "Top Garsonjera",
};

export const DEFAULT_RECOMMENDATION_FIELDS = {
  lux: false,
  exclusive: false,
  new: false,
  top: true,
  urgent: false,
  cheap: true,
  top_studio: false,
};

export const PROPERTY_CATEGORIES = [
  { id: "sale", label: "Prodaja" },
  { id: "rental", label: "Izdavanje" },
];

export const generateYears = () => {
  let currentYear = new Date().getFullYear() + 10;
  let earliestYear = 1950;
  const arr = [];
  while (currentYear >= earliestYear) {
    arr.push(currentYear);
    currentYear -= 1;
  }
  return arr;
};
